module.exports = __webpack_public_path__ + "static/media/signal.990ad08d.svg";